import type { HTMLAttributes } from "react";

import type { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const HORIZONTAL_RULE_BASE_CLASS = "w-full border-0 border-t";

export const HORIZONTAL_RULE_COLOR_CLASS_MAP = {
  default: "border-sys-grey-50",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type THorizontalRuleColor = keyof typeof HORIZONTAL_RULE_COLOR_CLASS_MAP;

export type THorizontalRuleProps = {
  color?: THorizontalRuleColor;
} & HTMLAttributes<HTMLHRElement>;

type THorizontalRuleDefaultProps = DefinedDefaults<
  THorizontalRuleProps,
  "color"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const HORIZONTAL_RULE_DEFAULTS = {
  color: "default",
} satisfies THorizontalRuleDefaultProps;
